// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';

// initial state
// shape: [{ id, quantity }]
import BaseModule from "@/store/_base_module";

const state = {
  available_slots: [],
  data: [],

  interval: 60,
  duration: 60,
};

// getters
const getters = {
  find(state, getters, rootState, rootGetters) {
    return (id, models) => {
      let models_array = getters.training_sessions.filter(model => {
        return model.id === parseInt(id);
      });

      return models_array.length ? models_array[0] : null;
    };
  },
  available_slots(state, getters, rootState, rootGetters) {
    let available_slots = state.available_slots;

    available_slots.forEach(available_slot => {
      let racks_left = available_slot.available_racks_list.length;
      let percentage_left = ((racks_left / available_slot.total_racks_count) * 100);
      available_slot.full = false;

      // Lets decide on the color based on the amount of reserved racks
      let color = '#61fa40';
      // if(percentage_left > 0) {
      //   color = '#ff8200';
      // }
      // We never get zero here, stupidly enough, but Infinity, and beyond!
      if(percentage_left === 0) {
        color = '#c9c9c9';
        available_slot.full = true;
      }
      // BUT if the current user has reserved this slot, we make it BLUE
      let users = '';
      let isCurrentUser = false;
      // Soms blijft het hangen in de localStorage
      if(typeof available_slot.reserved_by !== 'undefined') {
        available_slot.reserved_by.forEach(user => {
          if(user.id) {
            users += user.first_name + ' ' + user.last_name;
            // TODO deze geeft een rare error:
            // [Vue warn]: Error in callback for watcher "availableSlots": "TypeError: Cannot read property 'getValue' of undefined"
            // ...maar heeft verder geen effect
            if(rootGetters['current_user/id'] == user.id) {
              isCurrentUser = true;
            }
          }
        });
      }

      available_slot.reserved_by_self = false;
      // If we get a few, there are obbiously multiple users
      if(isCurrentUser) {
        color = '#0088ff';
        available_slot.reserved_by_self = true;
      }

      available_slot.color = color;

      // En hier setten we de description
      let gym_name = available_slot.gym.street + ', ' + available_slot.gym.city;
      available_slot.description = users.length ? users : gym_name;
      available_slot.gym_name = gym_name;
    });

    return available_slots;
  }
};

// actions
const actions = {
  /**
   * Fetches the available TrainingSlots based on Gym
   * @param state
   * @param commit
   * @param dispatch
   * @param getters
   * @param rootState
   * @param payload
   */
  availability ({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('api/getEndpoint', {
      endpoint: '/training-slots/availability',
      data: payload,
    }, {root: true}).then(response => {
      commit('set_state', {property: 'available_slots', value: response.data.data});
    });
  },
  /**
   * Stores a new TrainingSlot based on the Gym
   *
   * @param state
   * @param commit
   * @param dispatch
   * @param getters
   * @param rootState
   * @param rootGetters
   * @param payload
   */
  store ({state, commit, dispatch, getters, rootState, rootGetters}, payload) {
    return dispatch('api/postEndpoint', {
      endpoint: '/users/' + rootGetters['current_user/id'] + '/gyms/' + payload.gym_id + '/training-slots',
      data: payload,
    }, {root: true}).then(response => {
      // commit('set_state', {property: 'available_slots', value: response.data.data});
    });
  },
  /**
   * Destroy an existing TrainingSlot based on the Gym
   *
   * @param state
   * @param commit
   * @param dispatch
   * @param getters
   * @param rootState
   * @param rootGetters
   * @param payload
   */
  destroy({state, commit, dispatch, getters, rootState, rootGetters}, payload) {
    let endpoint = '/users/' + payload.training_slot.user_id + '/training-slots/' + payload.training_slot.id;
    return dispatch('api/deleteEndpoint', {
      endpoint: endpoint,
      data: payload,
    }, {root: true}).then(response => {
      // commit('set_state', {property: 'available_slots', value: response.data.data});
    });
  },
  /**
   * BOOK-02. Confirm this booking's currently-open stage.
   *
   * The request carries only a `source`. WHICH stage it confirms is the server's
   * decision, from the clock -- so one tap cannot pre-satisfy all three stages, which
   * is what BOOK-10 forbids. There is deliberately no `stage` in the payload: a client
   * that could name the stage could confirm stage 3 while stage 1 is being asked.
   *
   * `source` is EVIDENCE, never a control. The client computes it from local state a
   * member could edit, and the server branches on nothing -- pinned server-side by
   * 41-04's `the_stored_row_is_identical_whichever_source_was_sent`.
   *
   * NOT OPTIMISTIC, deliberately, and this diverges from notification_preferences.js
   * (which flips first and rolls back). A toggle is reversible in one tap; a
   * confirmation the member BELIEVES succeeded but did not is the failure that costs
   * them their slot in phase 42. Nothing changes here until the server answers, and
   * what it answers is what is stored. There is no local write in this action at all.
   *
   * @param {{training_slot_id: number|string, source: 'push'|'app'}} payload
   * @returns {Promise<{training_slot_id: number, confirmations: Object}|null>}
   */
  confirm({state, commit, dispatch, getters, rootState, rootGetters}, {training_slot_id, source}) {
    return dispatch('api/postEndpoint', {
      endpoint: '/training-slots/' + training_slot_id + '/confirmations',
      data: {source: source},
      // The category-specific message below is the ONE message this failure gets.
      // api/onError already emits a danger toast for every rejected request, and a
      // second toast about the same request is a duplicate, not more information.
      suppress_error_toast: true,
    }, {root: true})
      .then(response => {
        return (response && response.data && response.data.data) ? response.data.data : null;
      })
      .catch(error => {
        // The payload is an OBJECT, not the bare string the plan sketched.
        // `notifications/addDangerNotification` assigns `payload.cssClass`,
        // `payload.closeButtonColor` and `payload.position` onto what it is handed
        // (notifications.js:29-34); a store module is an ES module and therefore
        // strict mode, where assigning a property to a string primitive THROWS
        // TypeError. A bare string would turn a failed confirm into a crash inside
        // the very handler that exists to report it.
        dispatch('notifications/addDangerNotification', {
          message: 'We konden je bevestiging niet opslaan. Probeer het opnieuw.',
        }, {root: true});

        // The rejection is RE-THROWN, not swallowed. Suppression hides the TOAST, never
        // the rejection -- the caller has to know the confirm failed so it can re-enable
        // its button and leave the row unchanged (IC4).
        throw error;
      });
  },
};

// mutations
const mutations = {
  ...BaseModule.mutations,
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
